// Shared plan helpers for the Module 6 editor (no React in here).

export const PEDAGOGY_OPTIONS = [
  "Lecture Method", "Discussion Method", "Activity-Based Learning", "Project-Based Learning",
  "Inquiry-Based Learning", "Demonstration", "Experiment", "Case Study", "Role Play",
  "Group Work", "Peer Learning", "Storytelling",
];

export function mkId(prefix = "id") {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export const newChapter = (name = "") => ({
  id: mkId("ch"), chapterNo: "", chapterName: name, topics: [], pedagogies: [], customPedagogies: [],
  learningObjectives: [], competencies: [], customCompetencies: [],
});

export const newUnit = (n) => ({ id: mkId("unit"), unitNo: n ? `Unit ${n}` : "", unitName: "", chapters: [] });

/** What is still missing for a chapter to be submittable (mirrors the server). */
export function chapterIssues(ch) {
  const issues = [];
  if (!String(ch.chapterName || "").trim()) issues.push("name");
  if (!(ch.learningObjectives || []).some((x) => String(x || "").trim())) issues.push("objective");
  if (![...(ch.competencies || []), ...(ch.customCompetencies || [])].some((x) => String(x || "").trim())) issues.push("competency");
  return issues;
}

const FRIENDLY = { name: "a name", objective: "what students will learn", competency: "competencies" };
export const describeIssues = (issues) => issues.map((i) => FRIENDLY[i]).join(" · ");

/** "1. Fractions", "Chapter 2 - Decimals", "- Shapes" → clean names. */
export function parseChapterList(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map((line) => line.replace(/^\s*(?:chapter\s*)?(?:\d+[.)\-:]\s*|[-*•]\s*)/i, "").trim())
    .filter(Boolean);
}

/** Flat, ordered list of every chapter in a term with its unit. */
export function chaptersOfTerm(term) {
  const out = [];
  (term?.units || []).forEach((u, ui) => u.chapters.forEach((c) => out.push({ unit: u, unitIndex: ui, chapter: c })));
  return out;
}
